module.exports = __webpack_public_path__ + "img/kn_logo_standard_positive_rgb.45747659.svg";